import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { DistributedGenerationBigPage, DistributedGenerationBigPageProps } from "./DistributedGenerationBigPage";

export const EMPTY_PAGE_CONTENT: DistributedGenerationBigPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/distributed-generation/more-than-10kw";

export const DistributedGenerationBigPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<DistributedGenerationBigPageProps>("distributed_generation___more_than_10kw", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <DistributedGenerationBigPage {...routeProps} {...content} />;
};
